module.exports = __webpack_public_path__ + "static/media/gallery_011.5132811f.png";